import React from 'react';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import AreasAtuacao from './components/sections/AreasAtuacao';
import Procedimentos from './components/sections/Procedimentos';
import About from './components/sections/About';
import FAQ from './components/sections/FAQ';
import Footer from './components/layout/Footer';

function App() {
  return (
    <div className="overflow-x-hidden">
      <Header />
      <Hero />
      <AreasAtuacao />
      <Procedimentos />
      <About />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;